/* eslint-disable no-param-reassign */
import { Reducer } from 'redux';
import produce from 'immer';
import { IMedicalCertificateState, IMedicalCertificateTypes } from './types';

const INITIAL_STATE: IMedicalCertificateState = {
  data: [],
  loading: false,
  error: null,
};

const medicalCertificate: Reducer<IMedicalCertificateState> = (
  state = INITIAL_STATE,
  action,
) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case IMedicalCertificateTypes.MEDICAL_CERTIFICATE_GET_REQUEST: {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case IMedicalCertificateTypes.MEDICAL_CERTIFICATE_GET_SUCCESS: {
        draft.data = action.payload.data;
        draft.loading = false;
        draft.error = null;
        break;
      }
      case IMedicalCertificateTypes.MEDICAL_CERTIFICATE_GET_FAILURE: {
        draft.loading = false;
        draft.error = action.payload.error;
        break;
      }
      default:
        break;
    }
  });
};

export default medicalCertificate;
